// extracted by mini-css-extract-plugin
export default {"grid":"KpiRow_grid__W8dbO","card":"KpiRow_card__JwuZG","muted":"KpiRow_muted__uwYuz","value":"KpiRow_value__NZpy4"};